import React, { useEffect, useState, useCallback } from "react";
import { Button, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { useDropzone } from "react-dropzone";
import DropzoneWrapper from "../../components/util/Dropzone.style";
import { ReactComponent as CloudImg } from "../../assets/img-cloud.svg";
import Surface from "../../components/layouts/Surface";
import { Space } from "antd";
import { useIntl } from "react-intl";
import { BranchSelect } from "../../components/forms/AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import { setActiveBranch, uploadRevahaSchedulesFile } from "./ok2GoSlice";
import { useParams } from "react-router-dom";
const { Title, Text } = Typography;

const SchedulingsUpload = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { branchId } = useParams();
  const { activeBranch } = useSelector((state) => state.ok2Go);
  const [file, setFile] = useState(null);
  const loading = useSelector(
    (state) => state.pendingActions["ok2Go/upload_revaha_schedules_file"]
  );
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const selectedFile = acceptedFiles[0];
      const fileWithPreview = Object.assign(selectedFile, {
        preview: URL.createObjectURL(selectedFile),
        fileName: selectedFile.name,
      });
      setFile(fileWithPreview);
    }
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: 10485760,
    accept: ".txt",
  });
  const onDecline = () => {
    setFile(null);
  };
  const onUpload = async () => {
    if (file) {
      const params = {
        file: file,
        activeBranch,
      };
      console.log(params);
      const action = await dispatch(uploadRevahaSchedulesFile(params));
      if (!action.error) {
        setFile(null);
      }
    }
  };
  const onCancel = () => {
    setFile(null);
  };

  useEffect(() => {
    if (branchId) {
      dispatch(setActiveBranch(branchId));
    }
  }, [branchId, dispatch]);

  const handleBranchChange = (val) => {
    dispatch(setActiveBranch(val));
  };

  return (
    <Surface style={{ paddingTop: "10px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2>
          {intl.formatMessage({
            id: `app.settings.ok2Go_interfaces_schedulings`,
          })}
        </h2>
        <Space size="small">
          {!branchId && (
            <BranchSelect
              style={{ width: 170 }}
              placeholder={intl.formatMessage({ id: `app.users.chooseBranch` })}
              onChange={handleBranchChange}
            />
          )}
        </Space>
      </div>
      <div>
        <DropzoneWrapper>
          <div
            {...getRootProps({ className: "outer" })}
            style={{ padding: "0 60px" }}
          >
            <CloudImg />
            <input {...getInputProps()} />
            <p className="title">
              {
                <FormattedMessage id="app.actions.dragAndDropRevahaSchedulings" />
              }
            </p>
            <p className="subtitle">
              {<FormattedMessage id="app.actions.dragAndDropBtl2" />}
            </p>
            <p className="limit">
              {
                <FormattedMessage
                  id={
                    process.env.REACT_APP_CONFIG === "matav"
                      ? "app.actions.dragAndDropMatav3"
                      : "app.actions.dragAndDrop3"
                  }
                />
              }
            </p>
          </div>
          <div className="filesContainer">
            {file ? (
              <Title level={3} style={{}}>
                {<FormattedMessage id="app.titles.files" />}
              </Title>
            ) : null}
            {file && <Text>{file.name}</Text>}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <div>
              <Button
                disabled={!file || loading}
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={onUpload}
                size="large"
              >
                {<FormattedMessage id="app.actions.uploadFile" />}
              </Button>
              <Button
                style={{ margin: "0 10px" }}
                onClick={onCancel}
                size="large"
              >
                {<FormattedMessage id="app.actions.cancel" />}
              </Button>
            </div>
          </div>
        </DropzoneWrapper>
      </div>
    </Surface>
  );
};

export default SchedulingsUpload;
